import React, { Component } from "react";
import { arrayOf, shape, bool, string, func } from "prop-types";
import { Link } from "react-router-dom";
import Col from "react-bootstrap/lib/Col";

import { actions as checksActions } from "reducers/checks";
import Table from "pages/_components/Table";
import I18n from "pages/_components/I18n";
import Container from "pages/_components/Container";
import Image from "pages/_components/Image";
import Heading from "pages/_components/Heading";
import InfoTag from "pages/_components/InfoTag";
import FormattedAmount from "pages/_components/FormattedAmount";
import { checksDetailGetCodeMsg, checksDetailStatusTagColor, getChecksDetailAccountName } from "util/checks";
import CheckDetailItem from "./CheckDetailItem";

class ChecksDetailTable extends Component {
    static propTypes = {
        listCheckDetail: arrayOf(shape({})).isRequired,
        isDesktop: bool,
        tableLabel: string.isRequired,
        isEmittedSelected: bool.isRequired,
        dispatch: func.isRequired,
    };

    static defaultProps = {
        isDesktop: true,
    };

    handleCheckDetailClick = (checkDetail) => {
        const { dispatch } = this.props;
        dispatch(checksActions.setCheckDetail(checkDetail));
    };

    cheqsListMobile = (checkDetail, isEmittedSelected, tableLabel) => {
        const bankType = isEmittedSelected ? "depositary" : "issuing";
        const {
            numeroCheque: cheqNumber,
            descripcionEstadoCheque: state,
            importeCheque: amount,
            denominacionBancoDepositario: depositaryBank,
            denominacionBancoLibrador: delivererBank,
            codigoMonedaDebitoCheque: codeCurrencyDebit,
            codigoMonedaAcreditacionCheque: codeCurrencyAccreditation,
            fechaDepositoCheque: depositDate,
            fechaDebitoAcreditacionCheque: debitDate,
            numeroCheque: cheqId,
        } = checkDetail;

        return (
            <div className="container-white row my-2 mx-0" key={cheqId}>
                <Col xs={12} className="px-1">
                    <Link to={`/checksDetail/${cheqId}`} onClick={() => this.handleCheckDetailClick(checkDetail)}>
                        <Col xs={6}>
                            <Heading.DataGroup
                                containerClassName="transfer-data wrap data-wrapper-flex space-between mt-2"
                                dataClassName="data-desc small-font"
                                label="discountedChecksDetail.checkNumber.label"
                                data={cheqNumber}
                            />
                        </Col>
                        <Col xs={6} className="px-2 pt-2">
                            <div className="justify-content-end d-flex w-100">
                                <InfoTag
                                    type="info"
                                    message={checksDetailGetCodeMsg(state)}
                                    tagBackground={checksDetailStatusTagColor(state)}
                                    moreStyles={{
                                        display: "flex",
                                        alignSelf: "flex-end",
                                        width: "fit-content",
                                        color: "black",
                                        margin: "0.5rem 0",
                                    }}
                                />
                            </div>
                        </Col>
                        <Col xs={12} className="pr-2">
                            <Heading.DataGroup
                                containerClassName="transfer-data data-wrapper-flex space-between"
                                dataClassName="data-desc small-font"
                                label={`${tableLabel}.table.account`}
                                data={getChecksDetailAccountName({ ...checkDetail, isEmittedSelected })}
                            />
                        </Col>
                        <Col xs={12} className="pr-2">
                            <Heading.DataGroup
                                containerClassName="transfer-data data-wrapper-flex space-between"
                                dataClassName="data-desc small-font"
                                label={`${tableLabel}.table.${bankType}Bank`}
                                data={isEmittedSelected ? depositaryBank : delivererBank}
                            />
                        </Col>
                        <Col xs={12} className="pr-2">
                            <Heading.DataGroup
                                containerClassName="transfer-data data-wrapper-flex space-between"
                                dataClassName="data-desc small-font"
                                label="echeq.depositDate"
                                data={depositDate}
                            />
                        </Col>
                        <Col xs={12} className="pr-2">
                            <Heading.DataGroup
                                containerClassName="transfer-data data-wrapper-flex space-between"
                                dataClassName="data-desc small-font"
                                label="echeqs.monto"
                                data={
                                    <FormattedAmount
                                        currency={isEmittedSelected ? codeCurrencyDebit : codeCurrencyAccreditation}
                                        quantity={amount}
                                        notBold
                                        small
                                    />
                                }
                            />
                        </Col>
                        <Col xs={12} className="pr-2">
                            <Heading.DataGroup
                                containerClassName="transfer-data data-wrapper-flex space-between"
                                dataClassName="data-desc small-font"
                                label="echeqs.fecha_debito"
                                data={debitDate}
                            />
                        </Col>
                    </Link>
                </Col>
            </div>
        );
    };

    render() {
        const { listCheckDetail, isDesktop, tableLabel, isEmittedSelected } = this.props;
        const bankType = isEmittedSelected ? "depositary" : "issuing";

        if (!isDesktop && listCheckDetail?.length) {
            return listCheckDetail.map((checkDetail) =>
                this.cheqsListMobile(checkDetail, isEmittedSelected, tableLabel),
            );
        }

        const list = listCheckDetail.map((checkDetail) => (
            <Table.Row
                className="container-white check-detail-item"
                key={checkDetail.numeroCheque}
                renderAs={Link}
                to={`/checksDetail/${checkDetail.numeroCheque}`}
                onClick={() => this.handleCheckDetailClick(checkDetail)}>
                <CheckDetailItem
                    key={`transaction-${checkDetail.numeroCheque}`}
                    checkDetail={checkDetail}
                    isDesktop={isDesktop}
                    isEmittedSelected={isEmittedSelected}
                />
            </Table.Row>
        ));

        const renderTable = (
            <Table className="my-0">
                <Table.Header className="container-white checks-table-wrapper">
                    <Table.HeaderData align="left">
                        <I18n component="span" id={`${tableLabel}.table.checkNumber`} />
                    </Table.HeaderData>
                    <Table.HeaderData>
                        <I18n id={`${tableLabel}.table.account`} />
                    </Table.HeaderData>
                    <Table.HeaderData>
                        <I18n id={`${tableLabel}.table.${bankType}Bank`} />
                    </Table.HeaderData>
                    <Table.HeaderData>
                        <I18n id={`${tableLabel}.table.depositDate`} />
                    </Table.HeaderData>
                    <Table.HeaderData align="right">
                        <I18n id={`${tableLabel}.table.amount`} />
                    </Table.HeaderData>
                    <Table.HeaderData>
                        <I18n id={`${tableLabel}.table.${isEmittedSelected ? "debitDate" : "chargeDate"}`} />
                    </Table.HeaderData>
                    <Table.HeaderData align="right">
                        <I18n id={`${tableLabel}.table.situation`} />
                    </Table.HeaderData>
                    <Table.HeaderData />
                </Table.Header>
                <Table.Body>{list}</Table.Body>
            </Table>
        );

        return (
            <Container className="flex-grow scrollable mt-65">
                <Col className="col col-12 px-0">
                    <div
                        className="bd-spacing-0-2"
                        ref={(tableRef) => {
                            this.child = tableRef;
                        }}>
                        {listCheckDetail.length ? (
                            renderTable
                        ) : (
                            <div className="text-center no-more-data" key="noMoreMovements">
                                <div className="illustration-wrapper">
                                    <Image src="images/loupeInFile.svg" className="svg-big-icon" />
                                </div>
                                <p className="text-lead" style={{ opacity: 1 }}>
                                    <I18n id={`${tableLabel}.empty.message`} />
                                </p>
                            </div>
                        )}
                    </div>
                </Col>
            </Container>
        );
    }
}

export default ChecksDetailTable;
